import NewsCarousel from './NewsCarousel'


export default NewsCarousel
